

import React, { useState, useEffect } from "react";
import { View, ScrollView, SafeAreaView, StyleSheet, Picker, Text, TouchableOpacity, Image, Modal } from "react-native";
import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from 'react-i18next';
import { i18n } from './../../../assets/lang/i18next';
const useStyles = makeStyles(() => ({
    textField: {
        width: "100%",
        marginTop: 20,
        marginLeft: "auto",
        marginRight: "auto",
        paddingBottom: 0,
        marginTop: 0,
        fontWeight: 500,
        fontSize: 13,
        direction: "rtl",
        "& .MuiFormLabel-root": {
            color: "black",
            textAlign: 'right',
            fontFamily: 'IranSans',
            fontSize: 13, direction: 'rtl', width: '100%',
        },
        "& .MuiInputLabel-asterisk": {
            color: '#d12023',
            fontWeight: 900,
        },
        "& .MuiInputBase-input": {
            color: '#333', textAlign: 'center'
        },
        '& label.Mui-focused': {
            color: '#333',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'yellow',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'white',
            },
            '&:hover fieldset': {
                borderColor: 'blue',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#333',
            },
        },

    },
    labelRoot: {
        right: 20,
    },
    shrink: {
        transformOrigin: "top right",
    },
    input: {
        color: "black", fontFamily: 'IranSans',
        fontSize: 13,

    },
    btn_calculate: {
        color: '#333',
        backgroundColor: 'gray',
        fontFamily: 'IranSans',
        fontSize: 13, fontWeight: 900,
    }
}));
const EvapratorByComp = props => {
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    const [MSGSardkganeSelected, setMSGSardkganeSelected] = useState('');
    const [isshowkarbari, setIsshowkarbari] = useState(false);
    const [tc, setTc] = useState(40);
    const [tedadevaprator, setTedadevaprator] = useState(1);
    const [brandcomprosor, setBrandcomprosor] = useState(1);
    const [mobared, setMobared] = useState("R22");
    const [modelcomprosor, Setmodelcomprosor] = useState();
    const [dbdamaytagh, SetDbdamaytagh] = useState('');
    const [dbdamaynahai, SetDbdamaynahai] = useState('');
    const [dbzekhamatdivar, SetDbzekhamatdivar] = useState('');
    const [dbzamansardsazi, SetDbzamansardsazi] = useState('');
    const [dbzaribbargiri, SetDbzaribbargiri] = useState('');
    const [dbdamayvorod, SetDbdamayvorod] = useState('');
    const [dbzarfiyatvijeh, SetDbzarfiyatvijeh] = useState('');
    const [dbafterenjemad, SetDbafterenjemad] = useState('');
    const [dbbeforeenjemad, SetDbbeforeenjemad] = useState('');
    const [dbenjemad, SetDbenjemad] = useState('');
    const [dbtanafosi, SetDbanafosi] = useState('');
    const [dbdeltatcomp, setDbDeltatComp] = useState(0);
    const [te, SetTe] = useState(0);
    const [karbari, setKarbari] = useState(0);
    const [datacomprosor, setComprosorData] = useState(() => { item => setComprosorData(item) });
    const [itemsCompTemp, setCompTempItems] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [errorlist, SetErrorList] = useState("");
    function GetInfoSardkhane(idsimpleprdt) {
        setKarbari(idsimpleprdt);
        fetch(`https://app.arshehkar.com/query/public/GetDataSimpleCal.php?id=${idsimpleprdt}`)
            .then(response => response.json())
            .then(async (responseJsontmp) => {
                SetDbdamaytagh(responseJsontmp["temproom"]);
                SetDbdamaynahai(responseJsontmp["finaltemp"]);
                SetDbzekhamatdivar(responseJsontmp["zekhamatdivarsaghf"]);
                SetDbzamansardsazi(responseJsontmp["zamansardsazi"]);
                SetDbzaribbargiri(responseJsontmp["zaribbargiri"]);
                SetDbdamayvorod(responseJsontmp["damayvorodmahsol"]);
                SetDbzarfiyatvijeh(responseJsontmp["zarfiyatgarmaeivijeh"]);
                SetDbafterenjemad(responseJsontmp["zarfiyatafter"]);
                SetDbbeforeenjemad(responseJsontmp["zarfiyatbefore"]);
                SetDbenjemad(responseJsontmp["damayenjemad"]);
                SetDbanafosi(responseJsontmp["zaribtanafos"]);
                setDbDeltatComp(responseJsontmp["deltatcomp"]);
                SetTe(((parseFloat(responseJsontmp["temproom"]) - parseFloat(responseJsontmp["deltatcomp"])) < parseFloat("-45") && (parseFloat(responseJsontmp["temproom"]) - parseFloat(responseJsontmp["deltatcomp"])) > parseFloat("-48")) ? "-45" : (parseFloat(responseJsontmp["temproom"]) - parseFloat(responseJsontmp["deltatcomp"])));
            })
    }
    function LISTComprosor(bndcomp, typemobared, motor) {
        setCompTempItems([]);
        fetch(`https://app.arshehkar.com/query/public/GetListCompByBrandDevice.php?brand=${bndcomp}&device=${typemobared}&motor=${motor}`)
            .then(response => response.json())
            .then(async (datacomprosor) => {
                const mapArray = datacomprosor.map(({ title, id }) => ({ label: title, value: title }));
                setCompTempItems(mapArray);
                if (datacomprosor.length > 0) {
                    Setmodelcomprosor(datacomprosor[0]["title"]);
                }
            })
    }
    function FUNCMOHASEBEH() {

        let fc = 0;
        if (karbari != 0) {
            switch (karbari==5?(dbdamaytagh-te).toString():dbdeltatcomp) {
                case "5":
                    fc = (0.7109825 + (0.02437231 * (te)) + (0.001258625 * (Math.pow(te, 2))) + (0.00003948019 * (Math.pow(te, 3))) + (0.0000006536131 * (Math.pow(te, 4))) + (0.000000004307692 * (Math.pow(te, 5))));
                    break;
                case "6":
                    fc = (0.8709434 + (0.03498631 * (te)) + (0.002442587 * (Math.pow(te, 2)) + (0.00009775781 * (Math.pow(te, 3))) + (0.000001914033 * (Math.pow(te, 4))) + (0.00000001421538 * (Math.pow(te, 5)))));
                    break;
                case "7":
                    fc = (1.050832 + (0.03611483 * (te)) + (0.00191451 * (Math.pow(te, 2))) + (0.0000595303 * (Math.pow(te, 3))) + (0.0000009655012 * (Math.pow(te, 4))) + (0.00000000625641 * (Math.pow(te, 5))));
                    break;
                case "8":
                    fc = (1.245332 + (0.0481014 * (te)) + (0.003071678 * (Math.pow(te, 2))) + (0.0001145338 * (Math.pow(te, 3))) + (0.00000213986 * (Math.pow(te, 4))) + (0.00000001538462 * (Math.pow(te, 5))));
                    break;
                case "9":
                    fc = (1.245332 + (0.0481014 * (te)) + (0.003071678 * (Math.pow(te, 2))) + (0.0001145338 * (Math.pow(te, 3))) + (0.00000213986 * (Math.pow(te, 4))) + (0.00000001538462 * (Math.pow(te, 5))));
                    break;
                case "10":
                    fc = (1.604168 + (0.06317434 * te) + (0.00436317 * (Math.pow(te, 2))) + (0.0001764953 * (Math.pow(te, 3))) + (0.00000357296 * (Math.pow(te, 4))) + (0.00000002758974 * (Math.pow(te, 5))));
                    break;
            }
            let qn = 0;
            let modelif = (karbari == 4 || karbari == 1 || karbari == 6 ? "HCE" : karbari == 2 ? "HCA" : karbari == 3 ? "HCF" : karbari == 5 ? "HCT" : "");            
            fetch(`https://app.arshehkar.com/query/public/GetKWCompByTcTe.php?te=${te}&tc=${tc}&comp_brand=${brandcomprosor}&device=${mobared}&title=${modelcomprosor}`)
                .then(response => response.json())
                .then(async (responseJsontmp) => {

                    if (responseJsontmp.length > 0) {
                        qn = (responseJsontmp[0]["ans"]) / (parseFloat(tedadevaprator) * fc);
                        switch (mobared) {
                            case "R22":
                                qn = qn;
                                break;
                            case "R134":
                                qn = parseFloat(qn) * parseFloat(0.97);
                                break;
                            case "R404a/R507a":
                                qn = parseFloat(qn) * parseFloat(1.05);
                                break;
                        }
                        props.navigation.navigate('EvapratorResult', { WHICH: 2, QN: qn, MODELIF: modelif,MOBARED:mobared });
                    }
                    else {
                        
                        SetErrorList(t('Thecompressorwasnotfoundinthesuggestedrange'));
                        setModalVisible(true);
                    }

                })
        }
        else {
            SetErrorList(t('selectyourcoldroomapplication'));
            setModalVisible(true);
        }

    }
    React.useEffect(() => {
        // LISTComprosor(brandcomprosor, mobared);
    }, []);

    return (
        <ScrollView>
            <SafeAreaView style={styles.container}>

                

                <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'space-between', width: '90%' }}>

                    <TouchableOpacity style={{ marginTop: 15, flex: 1, flexDirection: 'row' }} onPress={() => props.navigation.navigate('CompEvaprator')}>
                        <Image resizeMode="contain" source={require('../../../assets/icons/comparisonicon.png')} style={{ width: 35, height: 35 }} />
                        <Text style={{ fontSize: 12, marginTop: 7, fontFamily: 'IranSans', color: 'blue' }}>{t('ComparisonEvaprator')}</Text>
                    </TouchableOpacity>
                    <Text style={{ fontFamily: 'IranSans', fontWeight: 900, fontSize: 14, marginTop: 15, marginBottom: 10 }}>{t('Evaporatorselectionbasedoncompro')}</Text>

                </View>

                <View style={styles.centeredView}>
                    <Modal
                        animationType="slide"
                        transparent={true}
                        visible={modalVisible}
                        onRequestClose={() => {
                            Alert.alert("Modal has been closed.");
                            setModalVisible(!modalVisible);
                        }}
                    >
                        <View style={styles.centeredView}>
                            <View style={styles.modalView}>
                                <View style={[{ flexDirection: 'row', alignItems: 'center' }]}>
                                    <View
                                        style={{
                                            borderBottomWidth: 1,
                                            borderBottomColor: '#d12023',
                                            width: 100, flex: 1, height: 2
                                        }}
                                    />
                                    <View>
                                        <Text style={[styles.textStyle, { width: 50, textAlign: 'center', color: "#000" }]}>{t('error')}</Text>
                                    </View>
                                    <View
                                        style={{
                                            borderBottomWidth: 1,
                                            borderBottomColor: '#d12023',
                                            width: 100, flex: 1, height: 2
                                        }}
                                    />
                                </View>
                                <Text style={styles.modalText}>{errorlist}</Text>
                                <TouchableOpacity
                                    style={[styles.button, styles.buttonClose]}
                                    onPress={() => setModalVisible(!modalVisible)}
                                >
                                    <Text style={styles.textStyle}> {t('ok')} </Text>
                                </TouchableOpacity>
                            </View>
                        </View>
                    </Modal>
                </View>


                <View style={styles.form}>
                    <Text style={styles.titleform}>{t('selectyourrefrigerant')}</Text>
                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                        onValueChange={(itemValue, itemIndex) => {
                            setMobared(itemValue);

                        }}
                    >
                        <Picker.Item label="R22" value="R22" />
                        <Picker.Item label="R134" value="R134" />
                        <Picker.Item label="R404a/R507a" value="R404a/R507a" />
                    </Picker>
                    <Text style={styles.titleform}>{t('evapratorusage')}</Text>
                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                        onValueChange={(itemValue, itemIndex) => {
                            setKarbari(itemValue);
                            switch (itemValue) {
                                case '4':
                                    setMSGSardkganeSelected(() => {
                                        LISTComprosor(brandcomprosor, mobared, 1);
                                        setIsshowkarbari(true);
                                        return (
                                            <View>
                                                <Text>{t('Longtermstorageabovezeroofproductsthathavearespiratoryloadincludingallkindsoffruitsandvegetables')}</Text>
                                                <Text>{t('Thetemperatureofthecoldroomisequalto0degreesCelsius')}</Text>
                                                <Text>{t('temperaturedifferenceisequalto6degreesCelsius')}</Text>
                                            </View>
                                        )
                                    });
                                    GetInfoSardkhane(itemValue);
                                    break;
                                case '2':
                                    setMSGSardkganeSelected(() => {
                                        LISTComprosor(brandcomprosor, mobared, 1);
                                        setIsshowkarbari(true);
                                        return (
                                            <View>
                                                <Text>{t('Maintainingabovezeroallproductswithoutrespiratoryloadincludingdairyproductsproteinmaterialsetc')}</Text>
                                                <Text>{t('Thetemperatureofthecoldroomisequalto0degreesCelsius')}</Text>
                                                <Text>{t('temperaturedifferenceisequalto8degreesCelsius')}</Text>
                                            </View>
                                        )
                                    });
                                    GetInfoSardkhane(itemValue);
                                    break;
                                case '3':
                                    setMSGSardkganeSelected(() => {
                                        LISTComprosor(brandcomprosor, mobared, 2);
                                        setIsshowkarbari(true);
                                        return (
                                            <View>
                                                <Text>{t('Subzerostorageoffoodatlowtemperaturessuchasicecream')}</Text>
                                                <Text>{t('Thetemperatureofthecoldroomis25degreesCelsius')}</Text>
                                                <Text>{t('temperaturedifferenceisequalto6degreesCelsius')}</Text>
                                            </View>
                                        )
                                    });
                                    GetInfoSardkhane(itemValue);
                                    break;
                                case '6':
                                    setMSGSardkganeSelected(() => {
                                        LISTComprosor(brandcomprosor, mobared, 1);
                                        setIsshowkarbari(true);
                                        return (
                                            <View>
                                                <Text>{t('Precoolingofproteinmaterialssuchasmeatandchicken')}</Text>
                                                <Text>{t('Thetemperatureofthecoldroomisequalto0degreesCelsius')}</Text>
                                                <Text>{t('temperaturedifferenceisequalto5degreesCelsius')}</Text>
                                            </View>
                                        )
                                    });
                                    GetInfoSardkhane(itemValue);
                                    break;
                                case '1':
                                    setMSGSardkganeSelected(() => {
                                        LISTComprosor(brandcomprosor, mobared, 1);
                                        setIsshowkarbari(true);
                                        return (
                                            <View>
                                                <Text>{t('storingofallproteinmaterialsbelowzeroincludingmeatchickenandfish')}</Text>
                                                <Text>{t('Thetemperatureofthecoldroomisequalto18degreesCelsius')}</Text>
                                                <Text>{t('temperaturedifferenceisequalto7degreesCelsius')}</Text>
                                            </View>
                                        )
                                    });
                                    GetInfoSardkhane(itemValue);
                                    break;
                                case '5':
                                    setMSGSardkganeSelected(() => {
                                        LISTComprosor(brandcomprosor, mobared, 3);
                                        setIsshowkarbari(true);
                                        return (
                                            <View>
                                                <Text>{t('Quickfreezingofproducts')}</Text>
                                                <Text>{t('Thetemperatureofthecoldroomis40degreesCelsius')}</Text>
                                                <Text>{t('temperaturedifferenceisequalto5degreesCelsius')}</Text>
                                            </View>
                                        )
                                    });
                                    GetInfoSardkhane(itemValue);
                                    break;
                                default:
                                    setIsshowkarbari(true);
                            }
                        }}
                    >
                        <Picker.Item label={t('select')} value="0" />
                        <Picker.Item label={t('fruitstorage')} value="4" />
                        <Picker.Item label={t('Dairystorage')} value="2" />
                        <Picker.Item label={t('chilingstorage')} value="6" />
                        <Picker.Item label={t('MeatStorage')} value="1" />
                        <Picker.Item label={t('icecreamstorage')} value="3" />
                        <Picker.Item label={t('blastfreezer')} value="5" />
                    </Picker>
                    {isshowkarbari === true ?
                        <Text style={{ padding: 7, color: 'blue', fontSize: 12, fontFamily: 'IranSans', backgroundColor: '#d6d6d6', marginLeft: '10%', marginRight: '10%', borderRadius: 6, marginBottom: 7 }}>
                            {MSGSardkganeSelected}
                        </Text>
                        : null}


                    <Text style={styles.titleform}>{t('compressortype')}</Text>
                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                        onValueChange={(itemValue, itemIndex) => {
                            setBrandcomprosor(itemValue);
                            LISTComprosor(itemValue, mobared, karbari == "5" ? 3 : karbari == "3" ? 2 : 1);
                        }}
                    >
                        <Picker.Item label={t('Bitzer')} value="1" />
                        <Picker.Item label={t('Bock')} value="2" />


                    </Picker>

                    <Text style={styles.titleform}>{t('Compressormodel')}</Text>
                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                        onValueChange={(itemValue, itemIndex) => {
                            Setmodelcomprosor(itemValue);
                        }}
                    >
                        {itemsCompTemp.map((item, index) => {
                            return (
                                <Picker.Item
                                    key={index}
                                    label={item.label}
                                    value={item.value}
                                />
                            )
                        }
                        )
                        }
                    </Picker>


                    <Text style={styles.titleform}>{t('Weathercondition')}</Text>
                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                        onValueChange={(itemValue, itemIndex) => {
                            setTc(itemValue);
                        }}
                    >
                        <Picker.Item label={t('ColdRegions')} value="40" />
                        <Picker.Item label={t('TemperateRegions')} value="45" />
                        <Picker.Item label={t('TropicalRegions')} value="50" />
                    </Picker>



                    <TextField
                        label={t('Thenumberofevaporators')}
                        onFocus={(e) => e.target.select()}
                        variant="filled"
                        placeholder={t('Thenumberofevaporators')}
                        className={classes.textField}
                        required
                        type="number"
                        InputProps={{
                            className: classes.input
                        }}
                        InputLabelProps={{
                            classes: { root: classes.labelRoot, shrink: classes.shrink }
                        }}
                        margin="normal"
                        onChange={(e) => setTedadevaprator(e.target.value)}
                        value={tedadevaprator}
                    />


                    <TouchableOpacity onPress={() => {

                        FUNCMOHASEBEH();

                    }} style={{ backgroundColor: '#022a4c', color: 'white', padding: 15, margin: 15, borderRadius: 4 }}>
                        <Text style={styles.titlebutton}>
                            {t('Computing')}
                        </Text>
                    </TouchableOpacity>



                </View>
            </SafeAreaView>
        </ScrollView>
    )
}

export default EvapratorByComp;

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        backgroundColor: '#ebecec',

    }
    ,
    titleform: {
        marginBottom: 5,
        marginTop: 5,
        fontFamily: 'IranSans',
        fontSize: 13.8,
    }
    ,
    inputtext: {
        backgroundColor: '#fff',
        textAlign: 'center',
        borderColor: "gray",
        width: "100%",
        borderWidth: 1,
        borderRadius: 10,
        padding: 10, width: '100%', height: 30
    }
    ,
    dropdown: {
        height: 50,
        width: '100%',
        marginBottom: 10,
        fontFamily: 'IranSans',
        fontSize: 13,
        borderWidth: 0,
        textAlign: 'center',
        backgroundColor: '#c9c9c9',
        direction: 'rtl',



    },
    form: {
        width: '90%',
        backgroundColor: '#ddd',
        margin: 10,
        padding: 10,
        justifyContent: 'center',
        alignItems: 'stretch',
        shadowColor: '#000',
        shadowOffset: { width: 1, height: 0.5 },
        shadowOpacity: 0.7,
        shadowRadius: 3,
    }
    ,
    touchable: {
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 12,
        paddingHorizontal: 32,
        borderRadius: 4,
        elevation: 3,
        backgroundColor: 'blue',
        marginBottom: 15,
        margin: 15,
    },
    titlebutton: {

        fontSize: 14,
        lineHeight: 21,
        fontWeight: 'normal',
        fontFamily: 'IranSans',
        letterSpacing: 0.25,
        color: 'white',
        textAlign: 'center'

    },
    spinner: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: 'rgba(50,70,110,0.3)',
        bottom: 0,
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9000,
    },
    centeredView: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        marginTop: 10
    },
    modalView: {
        margin: 10,
        backgroundColor: "white",
        borderRadius: 20,
        padding: 15,
        width: '75%',
        alignItems: "center",
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 2
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5
    },
    button: {
        borderRadius: 20,
        padding: 10,
        elevation: 2
    },
    buttonOpen: {
        backgroundColor: "#F194FF",
    },
    buttonClose: {
        backgroundColor: "#06619b",
    },
    textStyle: {
        color: "white",
        fontWeight: 600,
        textAlign: "center",
        fontFamily: 'IranSans',
        fontSize: 14.1

    },
    modalText: {
        marginBottom: 10,
        textAlign: "center", fontFamily: 'IranSans', fontSize: 13.5,
    }

});
